import { render, staticRenderFns } from "./CSummaryProfile.vue?vue&type=template&id=71c99713&"
import script from "./CSummaryProfile.vue?vue&type=script&lang=js&"
export * from "./CSummaryProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports